/**
 * Shared constants used across multiple pages and components.
 * Only constants that are duplicated in 2+ files belong here.
 */

// Body parts / muscle groups for exercise filtering and categorization.
// Used by: ExercisePicker, CreateCustomExercise, ExerciseLibraryPage,
//          DatabasePage, RoutinesPage, WorkoutPage, RoutineEditor
export const BODY_PARTS = [
  'Back', 'Cardio', 'Chest', 'Lower Arms', 'Lower Legs',
  'Neck', 'Shoulders', 'Upper Arms', 'Upper Legs', 'Waist'
];

// Alias — some files reference this as MUSCLE_GROUPS
export const MUSCLE_GROUPS = BODY_PARTS;

// Workout difficulty levels.
// Used by: RoutinesPage, WorkoutPage
export const DIFFICULTY_LEVELS = ['Beginner', 'Intermediate', 'Advanced'];

// Full equipment list for exercise creation and library filtering.
// Used by: CreateCustomExercise, ExerciseLibraryPage
export const EQUIPMENT_LIST = [
  'Barbell', 'Dumbbell', 'Cable', 'Body Weight', 'Leverage Machine',
  'Smith Machine', 'EZ Barbell', 'Band', 'Kettlebell', 'Resistance Band',
  'Medicine Ball', 'Stability Ball', 'Rope', 'Weighted', 'Other'
];

// Shorter equipment list for the exercise picker filter.
// Used by: ExercisePicker
export const EQUIPMENT_LIST_SHORT = [
  'Barbell', 'Dumbbell', 'Cable', 'Body Weight', 'Leverage Machine',
  'Smith Machine', 'EZ Barbell', 'Band', 'Kettlebell', 'Resistance Band'
];
